export const NumberConstant = {
  GRAPHQL_MAX_INT: 2 ** 31 - 1,
};
